import type { ReactNode } from 'react';

export const symbol_loyalty: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M863-404 557-97q-9 8.5-20.25 12.75T514.25-80Q503-80 492-84.5T472-97L98-472q-8-8-13-18.96-5-10.95-5-23.04v-306q0-24.75 17.63-42.38Q115.25-880 140-880h307q12.07 0 23.39 4.87Q481.7-870.25 490-862l373 373q9.39 9 13.7 20.25 4.3 11.25 4.3 22.5t-4.5 22.75Q872-412 863-404ZM516-138l306-307-375-375H140v304l376 378ZM245-664q21 0 36.5-15.5T297-716q0-21-15.5-36.5T245-768q-21 0-36.5 15.5T193-716q0 21 15.5 36.5T245-664Zm236 185Zm63 195 119-119q11-11 16-24.4 5-13.41 5-28.6 0-31.93-22.54-54.46Q638.93-533 607-533q-20.36 0-40.18 13T523-478q-24-29-43.29-42T440-533q-31.93 0-54.46 22.54Q363-487.93 363-456q0 15.19 5 28.6 5 13.4 16 24.4l118 119q9 9 21 9t21-9Z"
		/>
	</svg>
);
